import {observable} from 'mobx';

export default class MarkupStyleSettings {
	@observable hide_group_items;
	@observable row_limit;

	@observable is_plugin_css_used;

	@observable groups_header_font_size;

	@observable simple_group_font_color;
	@observable simple_group_background_color;
	@observable simple_group_border_color;
	@observable simple_group_border_width;
	@observable simple_group_active_border_color;
	@observable simple_group_border_hover_color;

	@observable photo_group_item_height;
	@observable photo_group_item_width;
	@observable photo_group_border_radius;
	@observable photo_group_border_color;
	@observable photo_group_active_border_color;

	@observable color_group_border_color;
	@observable color_group_border_hover_color;
	@observable color_group_border_width;
	@observable color_group_active_border_color;
	@observable color_group_border_radius;

	constructor(settings) {
		if (settings) {
			this.hide_group_items = settings.hide_group_items;
			this.row_limit = settings.row_limit;
			this.is_plugin_css_used = settings.is_plugin_css_used;

			this.groups_header_font_size = settings.groups_header_font_size;

			this.simple_group_font_color = settings.simple_group_font_color;
			this.simple_group_background_color = settings.simple_group_background_color;
			this.simple_group_border_color = settings.simple_group_border_color;
			this.simple_group_border_width = settings.simple_group_border_width;
			this.simple_group_active_border_color = settings.simple_group_active_border_color;
			this.simple_group_border_hover_color = settings.simple_group_border_hover_color;

			this.photo_group_item_height = settings.photo_group_item_height;
			this.photo_group_item_width = settings.photo_group_item_width;
			this.photo_group_border_radius = settings.photo_group_border_radius;
			this.photo_group_border_color = settings.photo_group_border_color;
			this.photo_group_active_border_color = settings.photo_group_active_border_color;

			this.color_group_border_color = settings.color_group_border_color;
			this.color_group_border_hover_color = settings.color_group_border_hover_color;
			this.color_group_border_width = settings.color_group_border_width;
			this.color_group_active_border_color = settings.color_group_active_border_color;
			this.color_group_border_radius = settings.color_group_border_radius;
		}
	}
}